module.exports = __webpack_public_path__ + "c2146ef1f06547753ba62f3e705970bd.svg";